import styled from 'styled-components';

export const PreviewImage = styled.img`
  width: 100%;
  border-radius: 12px;
  align-self: stretch;
  height: 100%;
  object-fit: cover;
  aspect-ratio: 4 / 3;
  pointer-events: none;
`;
